import React from "reactn";

import PropTypes from "prop-types";

//components
import CollectableContainer from "../collectable_containers/CollectableContainer";

const ProductList = props => {
    const { values, config } = props;
    return (
        <>
            {config.map(data => (
                <CollectableContainer values={values} title={data.title} desc={data.desc} products={data.products}></CollectableContainer>
            ))}
        </>

    );
};

ProductList.propTypes = {
    config: PropTypes.object,
    values: PropTypes.array
};

export default ProductList;
